import example from './example.js';

export default {
    example,
};
